// import React, { useEffect, useState, useMemo } from "react";
// import { toast } from "react-toastify";
// import { useNavigate, useParams } from "react-router-dom";
// import {
//   createMatch,
//   updateMatch,
//   getMatchById,
// } from "../../services/matchService";
// import { getLeagues } from "../../services/leagueService";
// import { getTeams } from "../../services/teamService";

// const formatForInput = (date) => {
//   if (!date) return "";
//   if (date.length === 10) return `${date}T00:00`;
//   return date.replace(" ", "T").slice(0, 16);
// };

// export const AddMatchLayer = () => {
//   const navigate = useNavigate();
//   const { id } = useParams();

//   const [leagues, setLeagues] = useState([]);
//   const [teams, setTeams] = useState([]);
//   const [loading, setLoading] = useState(false);

//   const [teamAPreview, setTeamAPreview] = useState(null);
//   const [teamBPreview, setTeamBPreview] = useState(null);

//   const [form, setForm] = useState({
//     league_id: "",
//     team_a: "",
//     team_b: "",
//     match_date: "",
//     status: "upcoming",
//     admin_risk: "",
//   });

//   /* ================= LOAD ================= */
//   useEffect(() => {
//     getLeagues().then((res) => {
//       if (res?.status) setLeagues(res.data);
//     });

//     getTeams().then((res) => {
//       if (res?.status) setTeams(res.data);
//     });
//   }, []);

//   /* ================= EDIT MODE ================= */
//   useEffect(() => {
//     if (!id) return;

//     getMatchById(id).then((m) => {
//       if (!m) return;

//       setForm({
//         league_id: m.league_id,
//         team_a: m.team_a,
//         team_b: m.team_b,
//         match_date: formatForInput(m.match_date),
//         status: m.status,
//         admin_risk: m.admin_risk || "",
//       });

//       setTeamAPreview(m.team_a_img || null);
//       setTeamBPreview(m.team_b_img || null);
//     });
//   }, [id]);

//   /* ================= FILTER TEAMS BY LEAGUE ================= */
//   const filteredTeams = useMemo(() => {
//     if (!form.league_id) return [];
//     return teams.filter(
//       (t) => String(t.league_id) === String(form.league_id)
//     );
//   }, [teams, form.league_id]);

//   /* ================= CHANGE HANDLER ================= */
//   const handleChange = (e) => {
//     const { name, value } = e.target;

//     if (name === "league_id") {
//       // Reset teams when league changes
//       setForm({
//         ...form,
//         league_id: value,
//         team_a: "",
//         team_b: "",
//       });
//       setTeamAPreview(null);
//       setTeamBPreview(null);
//       return;
//     }

//     setForm({ ...form, [name]: value });
//   };

//   const handleTeamChange = (e) => {
//     const { name, value } = e.target;
//     setForm({ ...form, [name]: value });

//     const selected = filteredTeams.find((t) => t.name === value);

//     if (name === "team_a") setTeamAPreview(selected?.image_url || null);
//     if (name === "team_b") setTeamBPreview(selected?.image_url || null);
//   };

//   /* ================= SUBMIT ================= */
//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (!form.league_id || !form.team_a || !form.team_b) {
//       toast.error("League, Team A and Team B are required");
//       return;
//     }

//     if (form.team_a === form.team_b) {
//       toast.error("Team A and Team B cannot be same");
//       return;
//     }

//     const formData = new FormData();

//     Object.entries(form).forEach(([key, value]) => {
//       if (key === "match_date" && value) {
//         formData.append("match_date", value.replace("T", " ") + ":00");
//       } else {
//         formData.append(key, value);
//       }
//     });

//     formData.append("team_a_img", teamAPreview || "");
//     formData.append("team_b_img", teamBPreview || "");

//     setLoading(true);

//     try {
//       const res = id
//         ? await updateMatch(id, formData)
//         : await createMatch(formData);

//       if (res?.status) {
//         toast.success(id ? "Match updated" : "Match created");
//         navigate("/match-list");
//       } else {
//         toast.error(res?.message || "Operation failed");
//       }
//     } catch {
//       toast.error("Server error");
//     }

//     setLoading(false);
//   };

//   return (
//     <div className="container mt-4">
//       <div className="card shadow-sm">
//         <div className="card-body">
//           <h5>{id ? "Update Match" : "Create Match"}</h5>

//           <form onSubmit={handleSubmit}>
//             {/* League */}
//             <div className="mb-3">
//               <label>League</label>
//               <select
//                 className="form-select"
//                 name="league_id"
//                 value={form.league_id}
//                 onChange={handleChange}
//               >
//                 <option value="">Select League</option>
//                 {leagues.map((l) => (
//                   <option key={l.id} value={l.id}>
//                     {l.league_name}
//                   </option>
//                 ))}
//               </select>
//             </div>

//             {/* Teams */}
//             <div className="row">
//               <div className="col-md-6 mb-3">
//                 <label>Team A</label>
//                 <select
//                   className="form-select"
//                   name="team_a"
//                   value={form.team_a}
//                   onChange={handleTeamChange}
//                   disabled={!form.league_id}
//                 >
//                   <option value="">Select Team A</option>
//                   {filteredTeams.map((t) => (
//                     <option key={t.id} value={t.name}>
//                       {t.name}
//                     </option>
//                   ))}
//                 </select>

//                 {teamAPreview && (
//                   <img
//                     src={teamAPreview}
//                     width="60"
//                     className="mt-2 rounded"
//                     alt=""
//                   />
//                 )}
//               </div>

//               <div className="col-md-6 mb-3">
//                 <label>Team B</label>
//                 <select
//                   className="form-select"
//                   name="team_b"
//                   value={form.team_b}
//                   onChange={handleTeamChange}
//                   disabled={!form.league_id}
//                 >
//                   <option value="">Select Team B</option>
//                   {filteredTeams.map((t) => (
//                     <option key={t.id} value={t.name}>
//                       {t.name}
//                     </option>
//                   ))}
//                 </select>

//                 {teamBPreview && (
//                   <img
//                     src={teamBPreview}
//                     width="60"
//                     className="mt-2 rounded"
//                     alt=""
//                   />
//                 )}
//               </div>
//             </div>

//             {/* Date */}
//             <div className="mb-3">
//               <label>Match Date & Time</label>
//               <input
//                 type="datetime-local"
//                 className="form-control"
//                 value={form.match_date}
//                 onChange={(e) =>
//                   setForm({ ...form, match_date: e.target.value })
//                 }
//               />
//             </div>

//             {/* Status + Risk */}
//             <div className="row">
//               <div className="col-md-6 mb-3">
//                 <label>Status</label>
//                 <select
//                   className="form-select"
//                   name="status"
//                   value={form.status}
//                   onChange={handleChange}
//                 >
//                   <option value="upcoming">Upcoming</option>
//                   <option value="live">Live</option>
//                   <option value="closed">Closed</option>
//                 </select>
//               </div>

//               <div className="col-md-6 mb-3">
//                 <label>Admin Risk (%)</label>
//                 <input
//                   className="form-control"
//                   name="admin_risk"
//                   value={form.admin_risk}
//                   onChange={handleChange}
//                 />
//               </div>
//             </div>

//             <button className="btn btn-primary w-100" disabled={loading}>
//               {loading ? "Saving..." : id ? "Update Match" : "Create Match"}
//             </button>
//           </form>
//         </div>
//       </div>
//     </div>
//   );
// };


import React, { useEffect, useState, useMemo } from "react";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import {
  createMatch,
  updateMatch,
  getMatchById,
} from "../../services/matchService";
import { getLeagues } from "../../services/leagueService";
import { getTeams } from "../../services/teamService";

const formatForInput = (date) => {
  if (!date) return "";
  if (date.length === 10) return `${date}T00:00`;
  return date.replace(" ", "T").slice(0, 16);
};

export const AddMatchLayer = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  const [leagues, setLeagues] = useState([]);
  const [teams, setTeams] = useState([]);
  const [loading, setLoading] = useState(false);

  const [teamAPreview, setTeamAPreview] = useState(null);
  const [teamBPreview, setTeamBPreview] = useState(null);

  const [form, setForm] = useState({
    league_id: "",
    team_a: "",
    team_b: "",
    match_date: "",
    status: "upcoming",
    admin_risk: "",
  });

  // 1-second toast configuration
  const toastConfig = { autoClose: 1000 };

  /* ================= LOAD ================= */
  useEffect(() => {
    getLeagues().then((res) => {
      if (res?.status) setLeagues(res.data);
    });

    getTeams().then((res) => {
      if (res?.status) setTeams(res.data);
    });
  }, []);

  /* ================= EDIT MODE ================= */
  useEffect(() => {
    if (!id) return;

    getMatchById(id).then((m) => {
      if (!m) return;

      setForm({
        league_id: m.league_id,
        team_a: m.team_a,
        team_b: m.team_b,
        match_date: formatForInput(m.match_date),
        status: m.status,
        admin_risk: m.admin_risk || "",
      });

      setTeamAPreview(m.team_a_img || null);
      setTeamBPreview(m.team_b_img || null);
    });
  }, [id]);

  /* ================= FILTER TEAMS BY LEAGUE ================= */
  const filteredTeams = useMemo(() => {
    if (!form.league_id) return [];
    return teams.filter(
      (t) => String(t.league_id) === String(form.league_id)
    );
  }, [teams, form.league_id]);

  /* ================= CHANGE HANDLER ================= */
  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "league_id") {
      setForm({
        ...form,
        league_id: value,
        team_a: "",
        team_b: "",
      });
      setTeamAPreview(null);
      setTeamBPreview(null);
      return;
    }

    setForm({ ...form, [name]: value });
  };

  const handleTeamChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });

    const selected = filteredTeams.find((t) => t.name === value);

    if (name === "team_a") setTeamAPreview(selected?.image_url || null);
    if (name === "team_b") setTeamBPreview(selected?.image_url || null);
  };

  /* ================= SUBMIT ================= */
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!form.league_id || !form.team_a || !form.team_b) {
      toast.error("League, Team A and Team B are required", toastConfig);
      return;
    }

    if (form.team_a === form.team_b) {
      toast.error("Team A and Team B cannot be same", toastConfig);
      return;
    }

    const formData = new FormData();

    Object.entries(form).forEach(([key, value]) => {
      if (key === "match_date" && value) {
        formData.append("match_date", value.replace("T", " ") + ":00");
      } else {
        formData.append(key, value);
      }
    });

    formData.append("team_a_img", teamAPreview || "");
    formData.append("team_b_img", teamBPreview || "");

    setLoading(true);

    try {
      const res = id
        ? await updateMatch(id, formData)
        : await createMatch(formData);

      if (res?.status) {
        toast.success(id ? "Match updated" : "Match created", toastConfig);
        // Small delay so user can see the toast before redirect
        setTimeout(() => navigate("/match-list"), 1000);
      } else {
        toast.error(res?.message || "Operation failed", toastConfig);
      }
    } catch {
      toast.error("Server error", toastConfig);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container mt-4">
      <div className="card shadow-sm">
        <div className="card-body">
          <h5>{id ? "Update Match" : "Create Match"}</h5>

          <form onSubmit={handleSubmit}>
            {/* League */}
            <div className="mb-3">
              <label>League</label>
              <select
                className="form-select"
                name="league_id"
                value={form.league_id}
                onChange={handleChange}
              >
                <option value="">Select League</option>
                {leagues.map((l) => (
                  <option key={l.id} value={l.id}>
                    {l.league_name}
                  </option>
                ))}
              </select>
            </div>

            {/* Teams */}
            <div className="row">
              <div className="col-md-6 mb-3">
                <label>Team A</label>
                <select
                  className="form-select"
                  name="team_a"
                  value={form.team_a}
                  onChange={handleTeamChange}
                  disabled={!form.league_id}
                >
                  <option value="">Select Team A</option>
                  {filteredTeams.map((t) => (
                    <option key={t.id} value={t.name}>
                      {t.name}
                    </option>
                  ))}
                </select>

                {teamAPreview && (
                  <img
                    src={teamAPreview}
                    width="60"
                    className="mt-2 rounded"
                    alt=""
                  />
                )}
              </div>

              <div className="col-md-6 mb-3">
                <label>Team B</label>
                <select
                  className="form-select"
                  name="team_b"
                  value={form.team_b}
                  onChange={handleTeamChange}
                  disabled={!form.league_id}
                >
                  <option value="">Select Team B</option>
                  {filteredTeams.map((t) => (
                    <option key={t.id} value={t.name}>
                      {t.name}
                    </option>
                  ))}
                </select>

                {teamBPreview && (
                  <img
                    src={teamBPreview}
                    width="60"
                    className="mt-2 rounded"
                    alt=""
                  />
                )}
              </div>
            </div>

            {/* Date */}
            <div className="mb-3">
              <label>Match Date & Time</label>
              <input
                type="datetime-local"
                className="form-control"
                value={form.match_date}
                onChange={(e) =>
                  setForm({ ...form, match_date: e.target.value })
                }
              />
            </div>

            {/* Status + Risk */}
            <div className="row">
              <div className="col-md-6 mb-3">
                <label>Status</label>
                <select
                  className="form-select"
                  name="status"
                  value={form.status}
                  onChange={handleChange}
                >
                  <option value="upcoming">Upcoming</option>
                  <option value="live">Live</option>
                  <option value="closed">Closed</option>
                </select>
              </div>

              <div className="col-md-6 mb-3">
                <label>Admin Risk (%)</label>
                <input
                  className="form-control"
                  name="admin_risk"
                  value={form.admin_risk}
                  onChange={handleChange}
                />
              </div>
            </div>

            <button className="btn btn-primary w-100" disabled={loading}>
              {loading ? "Saving..." : id ? "Update Match" : "Create Match"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};